import React from 'react';
import { PaginationAndSortCommand } from '@eogile/agrements-common/src/components/table/tableTypes';
import { PaginatedListResponse } from '@eogile/agrements-common/src/api/apiTypes';
import { Card, CardContent, Table, TableBody, TableContainer } from '@mui/material';
import UsersTableHeader from '@eogile/agrements-common/src/user/list/components/UsersTableHeader';
import NoUsersFound from '@eogile/agrements-common/src/user/list/components/NoUsersFound';
import TablePagination from '@eogile/agrements-common/src/components/table/TablePagination';
import { PmuUsersSortableFields } from '../pmuUsersTypes';
import { PmuUser } from '../../pmuUserTypes';
import PmuUsersTableRow from './PmuUserTableRow';
import PmuUsersTableHeader from './PmuUsersTableHeader';

type Props = {
  onCommandChange: (newCommand: PaginationAndSortCommand<PmuUsersSortableFields>) => void;
  command: PaginationAndSortCommand<PmuUsersSortableFields>;
  paginatedUsers: PaginatedListResponse<PmuUser> | null;
  reloadUsers: () => Promise<void>;
};

const PmuUsersTable = ({ command, onCommandChange, paginatedUsers, reloadUsers }: Props) => {
  if (!paginatedUsers) {
    return null;
  }

  const { numberOfResults, results } = paginatedUsers;
  return (
    <Card>
      <UsersTableHeader numberOfUsers={numberOfResults} />
      <CardContent>
        {numberOfResults === 0 && <NoUsersFound />}
        {numberOfResults > 0 && (
          <>
            <TableContainer>
              <Table>
                <PmuUsersTableHeader onCommandChange={onCommandChange} command={command} />
                <TableBody>
                  {results.map((user) => (
                    <PmuUsersTableRow key={user.id} user={user} reloadUsers={reloadUsers} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination<PmuUsersSortableFields>
              numberOfResults={numberOfResults}
              onCommandChange={onCommandChange}
              command={command}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default PmuUsersTable;
